/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ERROR_STATE_MAP } from './ErrorStateConstants';
import './ErrorState.scss';
type Props = {
	match: Record<string, any>;
	locale: string;
};

/**
 * Checks if the locale should be Italicized
 * @return {Boolean} locale - the locale
 */
function isItalicizedLanguage(locale) {
	const nonItalicizedLanguages = ['ja', 'ko', 'zh-Hans', 'zh-Hant'];

	if (nonItalicizedLanguages.indexOf(locale) !== -1) {
		return false;
	}

	return true;
}

/**
 * Returns the error state map for the specified error type.
 * @param {string} type - the error type
 */
function getErrorMap(type) {
	switch (type) {
		case 1:
			return ERROR_STATE_MAP['404'];

		case 2:
			return ERROR_STATE_MAP['500'];

		default:
			return ERROR_STATE_MAP['404'];
	}
}

const ErrorState = ({ locale, match }: Props) => {
	const errorMap = getErrorMap(match.params.type);
	{
		/* <FormattedMessage 
    			id={errorMap.detail}
    		/> */
	}
	let errorStateJSX = (
		<div className='search-error-state-container-general'>
			<div className='error-content-container'>
				<img src={errorMap.icon} />
				<div className={errorMap.detailMessageClass}>
					<FormattedMessage id='app.search.errorstate.message.unavailable' />
				</div>
			</div>
		</div>
	);

	if (isItalicizedLanguage(locale)) {
		errorStateJSX = (
			<div className='search-error-state-container-general'>
				<div className='error-content-container'>
					<img src={errorMap.icon} />
					<div className={errorMap.detailMessageClass}>
						<div className='error-detail-message-italics'>
							<FormattedMessage id='app.search.errorstate.message.unavailable' />
						</div>
					</div>
				</div>
			</div>
		);
	}

	return errorStateJSX;
};

export default {
	component: ErrorState,
};
